import { motion } from "framer-motion";

const Philosophy = () => {
  return (
    <section
      data-testid="philosophy-section"
      className="relative py-24 md:py-32 lg:py-40 bg-anthracite-950 overflow-hidden"
    >
      {/* Soft radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.05),transparent_60%)]" />

      <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* Ornament */}
          <div className="flex items-center justify-center gap-3 mb-10">
            <div className="h-px w-12 bg-gold-500/40" />
            <svg width="10" height="10" viewBox="0 0 10 10" className="text-gold-500">
              <path d="M5 1 L9 5 L5 9 L1 5 Z" fill="currentColor" />
            </svg>
            <div className="h-px w-12 bg-gold-500/40" />
          </div>

          <span className="text-[10px] uppercase tracking-[0.5em] text-gold-500 mb-8 block">
            Filozófia
          </span>

          <blockquote
            data-testid="philosophy-quote"
            className="font-serif italic text-xl sm:text-2xl md:text-3xl lg:text-4xl text-cream/90 leading-[1.4] sm:leading-[1.35] font-light tracking-[-0.01em]"
          >
            Minden kezelésem a testi és lelki egyensúly visszatalálásáról szól —
            <span className="gold-gradient-text not-italic"> figyelmes, személyre szabott jelenléttel.</span>
          </blockquote>

          <div className="mt-10 inline-flex items-center gap-4">
            <div className="w-10 h-px bg-gold-500/50" />
            <span className="font-serif italic text-gold-500 text-base">Rostás Ibolya</span>
            <div className="w-10 h-px bg-gold-500/50" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Philosophy;
